<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <a href="#"> <i class="uil-home-alt"></i> </a>
            </router-link>
          </li>
          <li>
            <span> {{
              this.$t('report.company_dashboard.reports')
            }}
            </span>
          </li>
          <li>{{ this.$t('general.user_assignment _reports') }}</li>
        </ul>
      </nav>
    </div>

    <div class="section-header mb-lg-2 border-0 uk-flex-middle">
      <div class="section-header-left">
        <h2 class="uk-heading-line text-left">
          <span> {{ this.$t('general.user_assignment _reports') }}</span>
        </h2>
      </div>
    </div>
    <div v-if="error" class="uk-alert-danger mb-3" uk-alert>
      <a class="uk-alert-close" uk-close></a>
      <p style="color: red">
        <i class="uil-exclamation-triangle"></i> {{ error }}
      </p>
    </div>

    <div class="card">
      <!-- Card header -->
      <div class="card-header actions-toolbar border-0">
        <div class="d-flex justify-content-between align-items-center">
          <div class="row" style="width:100%">
            <div class=" col-md-1  search-icon ">
              <i class="uil-search"></i>
            </div>
            <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
              <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                class="uk-search-input shadow-0 uk-form-small" type="search" />
            </div>
          </div>

          <div class="d-flex">
            <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false" class="btn btn-icon btn-hover btn-circle"
              href="javascript:void(0)" title="">
              <i class="uil-list-ui-alt"></i>
            </a>
            <div class="uk-dropdown" uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
              <ul class="uk-nav uk-dropdown-nav">
                <li class="uk-active">
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'fullName')">{{ $t("sorting.a_z") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'fullName')">{{ $t("sorting.z_a") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'created_at')">
                    {{ $t("sorting.created_at_old") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'created_at')">
                    {{ $t("sorting.created_at_new") }}</a>
                </li>
              </ul>
            </div>

            <!-- Filter -->
            <a :uk-tooltip="$t('general.filter_list')" class="btn btn-icon btn-hover btn-circle"
              href="javascript:void(0)">
              <i class="uil-filter"></i>
            </a>

            <UserFilter :assignmentList="assignmentList" :has-status="true" :is-user-active="true"
              :reportAssignment="true" :show-content-type-filter="true" :show-provider-training-filter="true" @getFilter="getFilter($event)" />

            <excel-download-button :loading="isReportDownloading" :tooltipText="$t('filters.export_excell')"
              @download="exportUserAssignment" />

          </div>
        </div>
      </div>
      <!-- Table -->
      <default-loading v-if="user_loading"></default-loading>
      <template v-else>
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
              <tr>
                <th scope="col">{{ $t("general.username") }}</th>
                <th scope="col">{{ $t("users.reg_no") }}</th>
                <th scope="col">{{ $t("general.status") }}</th>
                <th scope="col">{{ $t("general.assignment_name") }}</th>
                <th scope="col">{{ $t("general.assignment_status") }}</th>
                <th scope="col">{{ $t("general.content_title") }}</th>
                <th scope="col">{{ $t("general.content_type") }}</th>
                <th scope="col">{{ $t('general.instructor_name') }}</th>
                <th scope="col">{{ $t('general.place_of_education') }}</th>
                <th scope="col">{{ $t('general.duration_of_training') }} ({{ $t('general.minute') }})</th>
                <th scope="col">{{ $t("general.duration") }}</th>
                <th scope="col">{{ $t('general.assignment_date') }}</th>
                <th scope="col">{{ $t("general.start_date") }}</th>
                <th scope="col">{{ $t("general.end_date") }}</th>
                <th scope="col"> {{ $t("general.deleted_at") }}</th>
                <th scope="col">{{ $t("general.content_point") }}</th>
                <th scope="col">{{ $t('general.completion_percentage') }}</th>
                <th scope="col">{{ $t('general.completion_status') }}</th>
                <th scope="col">{{ $t('general.completion_type') }}</th>
                <!-- <th scope="col">{{ $t('excel.heading.completion_date') }}</th> -->
                <th scope="col">{{ $t("general.created_at") }}</th>
              </tr>
            </thead>

            <tbody class="list">
              <template v-for="item in formattedItems">
                <tr>
                  <td>
                    <span :uk-tooltip="`title:${item.email};pos: right`">
                      {{ item.fullname }}</span>
                  </td>
                  <td>{{ item.registration_number }}</td>
                  <td>{{ item.user_status }}</td>
                  <td>{{ item.assignment_name }}</td>
                  <td>{{ item.assignment_status_id }}</td>
                  <td>{{ item.content_name }}</td>
                  <td>{{ item.category }}</td>
                  <td>{{ item.instructor_name }}</td>
                  <td>{{ item.education_place }}</td>
                  <td>{{ item.formattedDuration }}{{ $t('general.minute') }}</td>
                  <td>{{ item.userDuration }}</td>
                  <td>{{ item.assigned_date }}</td>
                  <td>{{ item.start_date }}</td>
                  <td>{{ item.end_date }}</td>
                  <td>{{ item.deleted_at }}</td>
                  <td>{{ item.completed_status === $t('general.completed') ? item.point : '-' }}</td>
                  <td>{{ item.contentCompletionPercentage }}%</td>
                  <td v-html="item.completed_status"></td>
                  <td>{{ item.completion_type }}</td>
                  <td>{{ item.created_at }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
      </template>
    </div>
  </div>
</template>

<script>
import reports, {
  GET_ITEMS,
  LOADING,
  MODULE_NAME,
  SUCCESS,
} from "@/core/services/store/reports.module";

import store from "@/core/services";
import moment from "moment-timezone";
import 'moment-timezone/data/packed/latest.json'; // Loads all timezone data
import axios from "axios";
import UserFilter from "@/view/company/User/Filter";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import Pagination from "@/assets/components/Pagination";
import ExcelDownloadButton from "@/view/components/buttons/ExcelDownloadButton.vue";
import { showError, showInfo } from "@/utils/alertUtils";
import {
  getAssignedCorporateAccess,
  applyAssignedCorporateToFilter,
} from "@/core/services/userCorporateAccess.service";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "ReportUsers",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, reports);
  },
  components: {
    ExcelDownloadButton,
    Pagination,
    UserFilter,
    DefaultLoading,
  },
  data() {
    return {
      from_date: null,
      to_date: null,
      pagination: null,
      assignment_id: [],
      error: null,
      page: 1,
      per_page: 10,
      formattedItems: [],
      assignmentList: [],
      isReportDownloading: false,
      filter: {
        search: null,
        order: "desc",
        sort: "id",
      },
      keepFilter: null,
      user_status: null,
      assignment_status: null,
      user_id: [],
      provider: null,
    };
  },
  computed: {
    user_loading() {
      return store.getters[_MODULE_NAME + "/" + LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
  },
  methods: {
    userStatus(statusId) {
      switch (statusId) {
        case 0:
          return this.$t('general.passive') // "Pasif";
        case 1:
          return this.$t('general.active')  //"Aktif";
      }
    },
    exportUserAssignment() {
      let self = this;
      this.isReportDownloading = true;
      let filters = {
        like: this.filter.search,
        page: this.page,
        per_page: this.per_page,
        sort: this.filter.sort,
        order: this.filter.order,
        user_status: this.user_status,
        provider: this.provider,
      };
      if (this.keepFilter) {
        const keepFilter = this.keepFilter;

        if (keepFilter.company_id) {
          filters['company_id'] = keepFilter.company_id;
        }

        // {id, name} listesi tutan filtreler API için id dizisine çevrilir
        Object.entries(keepFilter).forEach(([key, value]) => {
          if (!Array.isArray(value) || key === 'company_id') return;

          let ids = value.map((item) => item.id);

          // "Tümü" seçiliyse (id null) assignment_id gönderilmez
          if (key === 'assignment_id' && value.some((assignment) => assignment?.id === null)) {
            ids = null;
          }

          if (ids?.length > 0) {
            filters[key] = JSON.stringify(ids);
          }
        });
      }

      let url = `${process.env.VUE_APP_BACKEND_APP_URL}/api/report/export/user-assignments?`;
      url += `&sort=${this.filter.sort}`;
      url += `&order=${this.filter.order}`;
      url += `&assignment_ids=${filters.assignment_id}`;
      url += `&user_status=${filters.user_status}`;
      if (this.assignment_status !== null && this.assignment_status !== undefined) {
        url += `&assignment_status=${this.assignment_status}`;
      }

      if (filters.provider) {
        url += `&provider=${encodeURIComponent(filters.provider)}`;
      }

      if (this.keepFilter?.user_id) {
        url += `&user_id=${JSON.stringify(this.keepFilter.user_id)}`;
      }

      if (filters.branch_id) url += `&branch_id=${filters.branch_id}`;
      if (filters.department_id) url += `&department_id=${filters.department_id}`;
      if (filters.region_id) url += `&region_id=${filters.region_id}`;
      if (filters.title_id) url += `&title_id=${filters.title_id}`;
      if (filters.position_id) url += `&position_id=${filters.position_id}`;
      if (filters.corporate_id) url += `&corporate_id=${filters.corporate_id}`;
      if (this.from_date) url += `&from_date=${this.from_date}`;
      if (this.to_date) url += `&to_date=${this.to_date}`;
      if (filters.group_id) url += `&group_id=${filters.group_id}`;
      if (filters.file_category_ids) url += `&file_category_ids=${filters.file_category_ids}`;

      url += `&report=${Math.random() * 9999999}`;

      axios.get(url, {
        responseType: "blob"
      }).then(async (res) => {
        this.isReportDownloading = false;
        try {
          const text = await res.data.text();
          const jsonData = JSON.parse(text);

          if (jsonData.data) {
            showInfo(jsonData.data);
          } else {
            showInfo(this.$t('report.excel_inprogress_5_minute'));
          }
        } catch (error) {
          showInfo(this.$t('errors.error_occurred'));
        }
      }).catch((error) => {
        this.isReportDownloading = false;
        showError(error)
      })

    },

    filterResult(filter = null) {
      this.error = null;

      // Yeni filtre geldiyse sakla; gelmediyse (sayfalama, sıralama, yenileme)
      // en son uygulanan filtreyle devam et
      if (filter) {
        this.keepFilter = filter;
        this.assignment_id = filter.assignment_id;
        this.from_date = filter.from_date;
        this.to_date = filter.to_date;
        this.user_status = filter.user_status;
        this.assignment_status = filter.assignment_status;
        this.provider = filter.provider;
        this.user_id = Array.isArray(filter.user_id) ? [...filter.user_id] : [];
      }

      let filters = {
        like: this.filter.search,
        page: this.page,
        per_page: this.per_page,
        sort: this.filter.sort,
        order: this.filter.order,
      };

      // İstek her zaman saklanan son filtreden (keepFilter) kurulur
      const activeFilter = this.keepFilter || {};

      if (activeFilter.company_id) {
        filters['company_id'] = activeFilter.company_id;
      }

      // {id, name} listesi tutan filtreler API için id dizisine çevrilir
      Object.entries(activeFilter).forEach(([key, value]) => {
        if (!Array.isArray(value) || key === 'company_id') return;

        let ids = value.map((item) => item.id);

        // "Tümü" seçiliyse (id null) assignment_id gönderilmez
        if (key === 'assignment_id' && value.some((assignment) => assignment?.id === null)) {
          ids = null;
        }

        filters[key] = JSON.stringify(ids);
      });

      this.from_date ? filters['from_date'] = this.from_date : null
      this.to_date ? filters['to_date'] = this.to_date : null
      if (this.user_id && this.user_id.length > 0) {
        filters['user_id'] = JSON.stringify(this.user_id);
      }
      filters['user_status'] = activeFilter.user_status
      if (activeFilter.assignment_status !== null && activeFilter.assignment_status !== undefined) {
        filters['assignment_status'] = activeFilter.assignment_status
      }
      if (activeFilter.provider) {
        filters['provider'] = activeFilter.provider
      }
      store
        .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
          url: "api/report/user-assignments",
          filters: filters,
        })
        .then((response) => {
          if (response.status) {
            let results = [];
            let responseData = response.data;
            this.pagination = responseData;

            responseData.data.forEach((item) => {
              let completedStatus = this.$t('general.not_started') // "Başlamadı";

              if (item.contentStartDate) {
                completedStatus = this.$t('general.on_going') // "Devam Ediyor";
              }

              if (item.contentCompletedDate) {
                completedStatus = this.$t('general.completed') // "Tamamlandı";
              }

              let startDate = item.contentStartDate
                ? moment.tz(item.contentStartDate, "UTC").tz(this.timeZone()).format("DD/MM/YYYY HH:mm")
                : "-";

              let endDate = item.contentCompletedDate
                ? moment.tz(item.contentCompletedDate, "UTC").tz(this.timeZone()).format("DD/MM/YYYY HH:mm")
                : "-";

              let assignedDate = item.assignedDate
                ? moment.tz(item.assignedDate, "UTC").tz(this.timeZone()).format("DD/MM/YYYY")
                : "-";

              let deletedAt = item.deleted_at
                ? moment.tz(item.deleted_at, "UTC").tz(this.timeZone()).format("DD/MM/YYYY HH:mm")
                : "-";

              let userStatus = this.userStatus(item.status_id);
              let registrationNumber = item.registration_number || "-";

              results.push({
                registration_number: registrationNumber,
                user_status: userStatus,
                email: item.email.toLowerCase(),
                assignment_name: item.assignmentName,
                content_name: item.programContentName
                  ? `${item.contentName} - ${item.programContentName}`
                  : item.contentName,
                category: item.fileCategoryName,
                fullname: item.fullName,
                instructor_name: item.instructor_name ?? '-',
                education_place: item.education_place ?? '-',
                formattedDuration: item.formattedDuration,
                assigned_date: assignedDate,
                duration: item.contentDuration ? item.contentDuration : '-',
                userDuration: item.userDuration ? item.userDuration : '-',
                point: item.contentPoint,
                start_date: startDate,
                end_date: endDate,
                deleted_at: deletedAt,
                contentCompletionPercentage: item.contentCompletionPercentage,
                completed_status: completedStatus,
                completion_type: item.is_compulsory ? this.$t('general.compulsory') : this.$t('general.not_compulsory'),
                // completed_at: completedDate,
                created_at: item.assignmentDate
                  ? moment.tz(item.assignmentDate, "UTC").tz(this.timeZone()).format("DD/MM/YYYY")
                  : "-",
                assignment_status_id: item.assignment_status_id === 1 ? this.$t('general.active') : this.$t('general.passive')
              });
            });
            this.formattedItems = results;
          }
        });
    },
    getAssignments() {
      let self = this;
      let filters = {
        page: 0,
        sort: "id",
        order: "desc",
        per_page: this.per_page,
      };
      store.dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
        url: "api/report/get-assignments",
        filters: filters,
      })
        .then((response) => {
          self.assignmentList = [
            {
              id: null,
              name: this.$t('general.all')
            },
          ];
          if (response.status) {
            let results = [];
            let items = response.data;
            items.forEach((item) => {
              self.assignmentList.push({
                id: item.id,
                name: item.full_name,
                order_number: item.order_number,
                status_id: item.status_id
              });
            });
            //this.assignmentList = results;
          }
        });
    },
    sortOrder(order, sort) {
      this.page = 1;
      this.filter.order = order;
      this.filter.sort = sort;
      this.filterResult();
    },
    setPage(page) {
      this.page = page;
      this.filterResult();
    },
    getFilter(value) {
      this.page = 1
      this.filterResult(value);
    },
  },
  async mounted() {
    // company_admin değilse ve bir şirkete atanmışsa
    // ilk yüklemede sadece o şirketin verisi gelsin.
    // Not: İlk listeleme getAssignments sonrası success watcher'ı ile tetiklendiği
    // için keepFilter, getAssignments çağrılmadan önce hazırlanmalı.
    const corporateAccess = await getAssignedCorporateAccess();
    this.keepFilter = applyAssignedCorporateToFilter(this.keepFilter, corporateAccess);

    this.getAssignments();
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);
  },
  watch: {
    success: function (val) {
      if (val) {
        this.filterResult();
      }
    },
    "filter.search": function () {
      this.debouncedFilterSearch();
    },
  },
};
</script>

<style scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-alert {
  margin: 0;
}
</style>
<style>
.multiselect__tag {
  color: white;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #3e416d;
}

.multiselect__tag-icon {
  background-color: transparent;
  line-height: 2.2;
}

.multiselect__tag-icon:after {
  color: #fff;
}

.multiselect__tag-icon:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.multiselect__input {
  border: unset !important;
}

.multiselect__tags .multiselect__input {
  border: unset !important;
}

.uk-tooltip {
  word-wrap: break-word;
  font-size: 10px !important;
}
</style>
